import { Box, Flex, IconButton, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { useAppConfig } from "../../context";
import { useRightSidebar } from "../../context/RightSidebarContext";
import { BookOpenText } from "@phosphor-icons/react";
import KnowledgeBase from "pages/KnowledgeBase";

import RightSidebarWidget from "./RightSidebarWidget";

function Layout({ sidebar, navbar, children }) {
  const { storedSidebarState, sidebarState } = useAppConfig();

  const sidebarW = useBreakpointValue({
    base: "full",
    md: "14",
    lg: storedSidebarState ? "64" : "14",
  });

  const sidebarBorder = useBreakpointValue({
    base: "none",
    md: "thin",
  });

  const contentOpacity = useBreakpointValue({
    base: sidebarState ? 0 : 1,
    lg: 1,
  });

  const contentPointerEvents = useBreakpointValue({
    base: sidebarState ? "none" : "all",
    lg: "all",
  });

  const navbarBg = useColorModeValue("white", "gray.800");

  return (
    <>
      {navbar && (
        <Box
          position="fixed"
          top={0}
          insetInline={0}
          bg={navbarBg}
          zIndex={20}
          borderBottom="1px"
          borderColor="gray.300"
        >
          {navbar}
        </Box>
      )}
      <Flex id="layout" direction="column" blockSize="100vh" inlineSize="full" overflow="hidden">
        {/* Spacer for the fixed navbar */}
        {navbar && <Box flexShrink={0} h="71px" />}
        <Flex flexGrow={1} overflow="hidden" blockSize="full">
          {sidebar && (
            <Box
              borderInlineEndWidth={sidebarBorder}
              inlineSize={sidebarW}
              blockSize="full"
              transitionTimingFunction="ease"
              transitionDuration="200ms"
              bg="#1155a5"
            >
              {sidebar}
            </Box>
          )}
          <Box
            id="layoutContainer"
            flex={1}
            blockSize="full"
            overflowY="auto"
            overflowX="hidden"
            opacity={contentOpacity}
            pointerEvents={contentPointerEvents}
            transitionTimingFunction="ease"
            transitionDuration="200ms"
          >
            <Box flexGrow={1} zIndex={1} backgroundColor="layout_background">
              {children}
            </Box>
          </Box>
        </Flex>
      </Flex>
      <RightSidebarWidget />
      <GlobalKBButton />
    </>
  );
}

function GlobalKBButton() {
  const { topOffset, setRightSidebar, doOpen, isOpen, doClose, activationId } = useRightSidebar();

  // Hide when SecondaryHeader is present (it has its own KB button)
  // Hide when KB tray is open (tray header has its own close button)
  if (topOffset > 0) return null;
  if (activationId === "KB" && isOpen) return null;

  const toggleKB = () => {
    if ("KB" === activationId && isOpen) {
      doClose();
    } else {
      setRightSidebar(<KnowledgeBase />);
      doOpen("KB");
    }
  };

  return (
    <Box
      position="fixed"
      top="71px"
      right={0}
      zIndex={10}
      bg="white"
      borderBottom="1px solid"
      borderLeft="1px solid"
      borderColor="gray.200"
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="52px"
      h="52px"
    >
      <IconButton
        variant="ghost"
        icon={<BookOpenText size={20} />}
        color="darkTeal"
        borderRadius={0}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        aria-label="Knowledge Base"
        title="Knowledge Base"
        onClick={toggleKB}
      />
    </Box>
  );
}

export default Layout;
